"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var collapseSelectedBlocks_1 = require("../utils/collapseSelectedBlocks");
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
exports.TAGS_TO_UNWRAP = 'B,I,U,STRONG,EM,SUB,SUP,STRIKE,FONT,CENTER,H1,H2,H3,H4,H5,H6,UL,OL,LI,SPAN,P,BLOCKQUOTE,CODE,S,PRE'.split(',');
exports.TAGS_TO_STOP_UNWRAP = ['TD', 'TH', 'TR', 'TABLE', 'TBODY', 'THEAD'];
exports.ATTRIBUTES_TO_PRESERVE = ['href'];
/**
 * Clear all formats of selected blocks.
 * When selection is collapsed, only clear format of current block.
 * @param editor The editor instance
 * @param tagsToUnwrap Optional. A string array contains HTML tags in upper case which we will unwrap when clear format
 * @param tagsToStopUnwrap Optional. A string array contains HTML tags in upper case which we will stop unwrap if these tags are hit
 */
function clearBlockFormat(editor, tagsToUnwrap, tagsToStopUnwrap, attributesToPreserve) {
    if (tagsToUnwrap === void 0) { tagsToUnwrap = exports.TAGS_TO_UNWRAP; }
    if (tagsToStopUnwrap === void 0) { tagsToStopUnwrap = exports.TAGS_TO_STOP_UNWRAP; }
    if (attributesToPreserve === void 0) { attributesToPreserve = exports.ATTRIBUTES_TO_PRESERVE; }
    editor.focus();
    editor.addUndoSnapshot(function (start, end) {
        var groups = [{}];
        var stopUnwrapSelector = tagsToStopUnwrap.join(',');
        // 1. Collapse the selected blocks and get first and last element
        collapseSelectedBlocks_1.default(editor, function (element) {
            var group = groups[groups.length - 1];
            var td = editor.getElementAtCursor(stopUnwrapSelector, element);
            if (td != group.td && group.first) {
                groups.push((group = {}));
            }
            group.td = td;
            group.first = group.first || element;
            group.last = element;
        });
        groups
            .filter(function (group) { return group.first; })
            .forEach(function (group) {
            // 2. Collapse with first and last element to make them under same parent
            var nodes = editor.collapseNodes(group.first, group.last, true /*canSplitParent*/);
            // 3. Continue collapse until we can't collapse any more (hit root node, or a table)
            if (canCollapse(tagsToStopUnwrap, nodes[0])) {
                while (editor.contains(nodes[0].parentNode) &&
                    canCollapse(tagsToStopUnwrap, nodes[0].parentNode)) {
                    nodes = [roosterjs_editor_dom_1.splitBalancedNodeRange(nodes)];
                }
            }
            // 4. Clear formats of the nodes
            nodes.forEach(function (node) {
                return clearNodeFormat(node, tagsToUnwrap, tagsToStopUnwrap, attributesToPreserve);
            });
            // 5. Clear CSS of container TD if exist
            if (group.td) {
                var styles = group.td.getAttribute('style') || '';
                var styleArray = styles.split(';');
                styleArray = styleArray.filter(function (style) { return style.trim().toLowerCase().indexOf('border') == 0; });
                styles = styleArray.join(';');
                if (styles) {
                    group.td.setAttribute('style', styles);
                }
                else {
                    group.td.removeAttribute('style');
                }
            }
        });
        editor.select(start, end);
    }, "Format" /* Format */);
}
exports.default = clearBlockFormat;
function clearNodeFormat(node, tagsToUnwrap, tagsToStopUnwrap, attributesToPreserve) {
    if (node.nodeType != 1 /* Element */ || roosterjs_editor_dom_1.getTagOfNode(node) == 'BR') {
        return false;
    }
    // 1. Recursively clear format of all its child nodes
    var allChildrenAreBlock = roosterjs_editor_dom_1.toArray(node.childNodes)
        .map(function (n) { return clearNodeFormat(n, tagsToUnwrap, tagsToStopUnwrap, attributesToPreserve); })
        .reduce(function (previousValue, value) { return previousValue && value; }, true);
    if (!canCollapse(tagsToStopUnwrap, node)) {
        return false;
    }
    var returnBlockElement = roosterjs_editor_dom_1.isBlockElement(node);
    // 2. If we should unwrap this tag, put it into an array and unwrap it later
    if (tagsToUnwrap.indexOf(roosterjs_editor_dom_1.getTagOfNode(node)) >= 0 || allChildrenAreBlock) {
        if (returnBlockElement && !allChildrenAreBlock) {
            roosterjs_editor_dom_1.wrap(node);
        }
        roosterjs_editor_dom_1.unwrap(node);
    }
    else {
        // 3. Otherwise, remove all attributes
        clearAttribute(node, attributesToPreserve);
    }
    return returnBlockElement;
}
function clearAttribute(element, attributesToPreserve) {
    for (var _i = 0, _a = roosterjs_editor_dom_1.toArray(element.attributes); _i < _a.length; _i++) {
        var attr = _a[_i];
        if (attributesToPreserve.indexOf(attr.name.toLowerCase()) < 0 &&
            attr.name.indexOf('data-') != 0) {
            element.removeAttribute(attr.name);
        }
    }
}
function canCollapse(tagsToStopUnwrap, node) {
    return tagsToStopUnwrap.indexOf(roosterjs_editor_dom_1.getTagOfNode(node)) < 0;
}
//# sourceMappingURL=clearBlockFormat.js.map